module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_3016.26729184.png";